import { MessageCircle } from "lucide-react";
import { useExplorer } from "@/context/ExplorerContext";
import { WHATSAPP_NUMBER, waLink, formatPhone } from "@/config";
import { Fr } from "@/components/lurio/Primitives";

export default function Footer() {
  const { t } = useExplorer();
  return (
    <footer data-testid="footer" className="border-t border-ink/10 bg-cream-deep px-5 py-14 sm:px-8 lg:px-12">
      <div className="mx-auto grid max-w-6xl gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-latin text-3xl font-semibold text-blue" dir="ltr">{t.brand}</p>
          <Fr className="mt-1 block text-lg italic text-coral">{t.bookTitle}</Fr>
          <p className="mt-4 max-w-xs text-sm leading-[1.8] text-ink-soft">{t.footer.tagline}</p>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow">{t.footer.whatsappLabel}</p>
          <a href={waLink()} data-testid="footer-whatsapp-link" className="mt-3 inline-flex min-h-[44px] items-center gap-2 font-bold text-ink hover:text-coral" target="_blank" rel="noreferrer">
            <MessageCircle size={18} className="text-[#25D366]" /> <bdi dir="ltr">{formatPhone(WHATSAPP_NUMBER)}</bdi>
          </a>
        </div>
        <div className="md:col-span-3 md:text-end">
          <span className="sticker inline-flex h-24 w-24 rotate-[-4deg] items-center justify-center bg-blue p-3 text-center font-serif text-sm font-bold leading-tight text-cream">{t.footer.made}</span>
        </div>
      </div>
      <p className="mx-auto mt-12 max-w-6xl text-xs text-ink-soft">{t.footer.legal}</p>
    </footer>
  );
}
